import {useAuthAxios} from 'hooks/api/useAuthAxios'
// @ts-ignore
import postWithFile from 'api/postWithFile'

type Params = {
  file: File
}

export const useUploadR510Csv = () => {
  const authAxios = useAuthAxios()
  return async (procedureStatusId: string, params: Params) => {
    const path = `/api/procedure_statuses/${procedureStatusId}/report_param_sets/r510_csv`
    return postWithFile(params, ['file'], authAxios.put.bind(authAxios, path))
  }
}
